/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Session } from './';
import {
    SessionFromJSON,
    SessionFromJSONTyped,
    SessionToJSON,
} from './';

/**
 * 
 * @export
 * @interface Sessions
 */
export interface Sessions {
    /**
     * 
     * @type {Array<Session>}
     * @memberof Sessions
     */
    sessions?: Array<Session>;
}

/**
 * Check if a given object implements the Sessions interface.
 */
export function instanceOfSessions(value: object): value is Sessions {
    return true;
}

export function SessionsFromJSON(json: any): Sessions {
    return SessionsFromJSONTyped(json, false);
}

export function SessionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sessions {
    if (json == null) {
        return json;
    }
    return {
        
        'sessions': json['sessions'] == null ? undefined : ((json['sessions'] as Array<any>).map(SessionFromJSON)),
    };
}

export function SessionsToJSON(value?: Sessions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sessions': value['sessions'] == null ? undefined : ((value['sessions'] as Array<any>).map((v) => SessionToJSON(v))),
    };
}

